import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Seo from '../components/seo/Seo';
import { CONTACT } from '../lib/contact';
import { blogRoot, localeFromPath, servicesRoot } from '../lib/i18n-routes';

/**
 * 404.
 *
 * SPA fallback tufayli server har qanday URL uchun 200 qaytaradi, shuning
 * uchun bu sahifa `noindex` bo'lishi shart — aks holda mavjud bo'lmagan
 * manzillar qidiruvga tushib, soft-404 to'lqinini hosil qiladi.
 */
function Page404() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const locale = localeFromPath(pathname);
    const home = locale === 'ru' ? '/ru' : '/';

    return (
        <main className="services-index">
            <Seo
                title={t('404-title')}
                description={t('404-desc')}
                lang={locale}
                path={pathname}
                noindex
            />

            <section className="svc-hero svc-hero--index">
                <div className="container">
                    <span className="brand-asterisk svc-hero__mark">&#10033;</span>
                    <p className="h8 sub-title">404</p>
                    <h1 className="svc-hero__title">{t('404-title')}</h1>
                    <p className="svc-hero__lead">{t('404-desc')}</p>

                    <div className="svc-hero__btns">
                        <Link to={home} className="tf-button btn-effect">
                            <span className="effect">{t('404-home')}</span>
                        </Link>
                        <a href={CONTACT.phoneHref} className="tf-button btn-effect ghost">
                            <span className="effect">{CONTACT.phoneDisplay}</span>
                        </a>
                    </div>

                    <ul className="svc-proof" style={{ marginTop: 34 }}>
                        <li>
                            <span>+</span>
                            <Link to={servicesRoot(locale)}>{t('all-services')}</Link>
                        </li>
                        <li>
                            <span>+</span>
                            <Link to={blogRoot(locale)}>{t('all-articles')}</Link>
                        </li>
                        <li>
                            <span>+</span>
                            <Link to={locale === 'ru' ? '/ru/contact' : '/contact'}>{t('connect')}</Link>
                        </li>
                    </ul>
                </div>
            </section>
        </main>
    );
}

export default Page404;
